import { z } from "zod";

export interface AccessTokenClaims {
  user_id: number;
  tenant_id: number;
  email: string;
  license: string;
  is_tenant_admin: boolean;
  is_super_admin: boolean;
  // Present (true) only for read-only sessions — encode() omits it when false.
  read_only?: boolean;
  exp: number;
}

export interface RefreshTokenClaims {
  type: string;
  jti: string;
  exp: number;
  user_id: number;
  intention: string;
}

export const TokenResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});

export type TokenResponse = z.infer<typeof TokenResponseSchema>;
